module.exports = __webpack_public_path__ + "img/thumb-melani.29e2b33c.png";